import "./Member.css";

export default function Member(props) {
  return (
    <div className="card">
      <div className="upper-margin"></div>
      <div className="card-img">
        <img src={props.img} />
      </div>
      <div className="card-name">{props.name}</div>
      <div className="card-role">{props.role}</div>
      <div className="card-location">
        <img src="/assets/images/location.png" />
        <span> {props.location}</span>
      </div>
      <div className="card-sentence">{props.sentence}</div>

      <div className="card-contact">
        {props.phone ? (
          <a href={props.phone}>
            <img src={"/assets/images/phone.svg"} />
          </a>
        ) : null}

        {props.mail ? (
          <a href={"mailto:" + props.mail}>
            <img src={"/assets/images/mail.svg"} />
          </a>
        ) : null}

        {props.facebook ? (
          <a href={props.facebook}>
            <img src={"/assets/images/facebook.svg"} />
          </a>
        ) : null}

        {props.instagram ? (
          <a href={props.instagram}>
            <img src={"/assets/images/instagram.svg"} />
          </a>
        ) : null}

        {props.dribbble ? (
          <a href={props.dribbble}>
            <img src={"/assets/images/dribbble.svg"} />
          </a>
        ) : null}

        {props.behance ? (
          <a href={props.behance}>
            <img src={"/assets/images/behance.svg"} />
          </a>
        ) : null}
      </div>
    </div>
  );
}
